module.exports = __webpack_public_path__ + "static/media/bitmap-04@3x.e59ae8c9.jpg";